import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import PulseLoader from "react-spinners/PulseLoader";
import { handleApiError } from "@utils/errorHandler";

const styles = {
  iframe: {
    width: "100%",
    height: "100%",
    border: "none",
  },
  container: {
    width: "100%",
    height: "100%",
    overflow: "hidden",
  },
  loader: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

const PDFViewer = ({ url, onError }) => {
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    if (!url) return undefined;

    let createdUrl = null;
    let cancelled = false;

    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        if (cancelled) return;
        // Force the blob to be treated as a PDF, ignoring server's
        // Content-Disposition: attachment header that would cause download.
        const pdfBlob = new Blob([response.data], { type: "application/pdf" });
        createdUrl = URL.createObjectURL(pdfBlob);
        setBlobUrl(createdUrl);
      })
      .catch((error) => {
        handleApiError(error);
        if (!cancelled && onError) {
          onError("Unable to load PDF. Please try downloading the file.");
        }
      });

    return () => {
      cancelled = true;
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [url]);

  if (!blobUrl) {
    return (
      <div style={styles.loader}>
        <PulseLoader color="#1bace4" size={15} />
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <iframe
        src={blobUrl}
        title="PDF Preview"
        style={styles.iframe}
        onError={onError}
      />
    </div>
  );
};

PDFViewer.propTypes = {
  url: PropTypes.string.isRequired,
  onError: PropTypes.func,
};

export default PDFViewer;
